import { show, showNewMessage } from '@intercom/messenger-js-sdk'

export const useIntercom = () => {
  return {
    show,
    showNewMessage
  }
}
